<template>
  <v-sheet :class="$vuetify.theme.dark ? 'blue-lighten-1 ' : 'white-lighten-1'">
    <v-card-text class="trade">
      <div class="icon-wrapper-body">
        <div class="icon-wrapper">
          <div class="icon-box">
            <slot name="icon">
              <!-- paste Live svg here -->
            </slot>
          </div>

          <div class="icon-content">
            <h3>Live</h3>
            <span>Account</span>
          </div>
        </div>

        <div class="iconClass icon-badge">
          <v-icon>mdi mdi-arrow-up</v-icon>
        </div>
      </div>

      <p class="amount">
        <span v-if="totalLiveAccounts">
          <countTo :startVal="startVal" :endVal="parseAmount(totalLiveAccounts)" :duration="3000" />
        </span>
        <span v-else>0</span>

        <router-link class="links" to="/registered-user?tab=3">See All</router-link>
      </p>
    </v-card-text>
  </v-sheet>
</template>

<script>
import { mapActions, mapState } from "vuex";
import { DASHBOARDAPIREQ__ACTIONS } from "@/store/action-types";
import countTo from "vue-count-to";
import { parseAmount } from "./utils";

export default {
  components: { countTo },
  data: () => ({ startVal: 0 }),
  computed: {
    ...mapState("dashboard", ["totalLiveAccounts"]),
  },
  methods: {
    ...mapActions("dashboard", [DASHBOARDAPIREQ__ACTIONS.TOTALLIVEACCOUNTS]),
    parseAmount,
  },
  async created() {
    await this[DASHBOARDAPIREQ__ACTIONS.TOTALLIVEACCOUNTS]();
  },
};
</script>
